import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { array, number, object, string } from "yup";
import { ProductManagementFormValues } from "src/models/ProductManagement.model";
import ProductManagement from "../Layouts/ProductManagement";
import { useAddProductManagementMutation } from "src/services/ProductManagementService";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddProductManagementWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: ProductManagementFormValues = {
    title: "",
    description: "",
    variants: [
      {
        price: "",
        modeId: "",
        noOfViews: "",
        batchRecording:""
      },
    ],
    books: [],
    images: [],
  };

  // Validation Schema
  const validationSchema = object().shape({
    title: string().required("Please enter title"),
    description: string(),
    variants: array().of(
      object({
        price: number()
          .min(0, "Please enter more then zero")
          .required("Please enter amount fees"),
        modeId: object().required("Please select mode"),
        noOfViews: string(),
        batchRecording:string(),
          // .min(0, "Please enter more then zero")
          // .required("Please enter views"),
      })
    ),
    books: array().required("Please select book"),
    images: array().of(string()),
  });
  const [addProductManagement] = useAddProductManagementMutation();

  // Handle Submit
  const handleSubmit = (
    values: ProductManagementFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ProductManagementFormValues>
  ) => {
    const formattedValues = {
      title: values.title,
      variants: values.variants.map((variant): any => ({
        price: variant.price,
        modeId: variant.modeId.value,
        noOfViews: variant.noOfViews,
        batchRecording:variant.batchRecording
      })),
      books: values.books.map((book) => book.value),
      images: values.images,
      description: values.description,
    };
    addProductManagement(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="md" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <ProductManagement
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddProductManagementWrapper;
